import { render, staticRenderFns } from "./TakipTalebiGosterForm.vue?vue&type=template&id=64a02c26&scoped=true"
import script from "./TakipTalebiGosterForm.vue?vue&type=script&lang=ts"
export * from "./TakipTalebiGosterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a02c26",
  null
  
)

export default component.exports